<template>
  <!-- FORM LOGIN BY EMAIL -->
  <div>
    <div class="email-login">
      <form @submit.prevent="loginByEmail">
        <div class="form-group input-group-lg">
          <label for="inputEmail1">Email</label>
          <input v-model="email" type="email" class="form-control" id="inputEmail1" required="true" placeholder="Enter email"/>
        </div>
        <div class="form-group input-group-lg">
          <label for="inputPassword1">Password</label>
          <input v-model="password" type="password" class="form-control" id="inputPassword1" required="true" placeholder="Password" />
        </div>
        <div class="form-group form-check px-0">
          <router-link to="/forgot-password">Lupa Kata Sandi</router-link>
        </div>
        <p class="text-center mt-5">
          <button type="submit" class="login-btn btn btn-primary bg-success text-white text-uppercase" style="border: none">Login</button>
          <div class="text-danger text-center">{{ error }}</div>
        </p>
      </form>
    </div>
  </div>
  <!-- FORM LOGIN BY EMAIL END -->
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    ...mapActions('account', ['login', 'loginByPhoneAction']),
    toggleLoginForm(selectedForm) {
      this.isLoginByEmail = false
      if(selectedForm == "email") {
        this.isLoginByEmail = true
      }
    },
    loginByEmail() {
      let self = this
      const { email, password } = this;

      if (email && password) {
        // go to store action
        this.login({ email, password })
      }
    }
  },
  computed: {
    ...mapState('account', ['error'])
  }
}
</script>